import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { trackEvent } from '../../analytics/sml/analytics';
import { TypedMemo } from '../../common/types';
import { SMLContainer } from '../../smartLinks/smlContainer/SMLContainer';
import { SMLPageHead } from '../components/SMLPageHead/SMLPageHead';
import { reviewMessages } from './reviewMessages';
import { reviewFromOf } from './reviewRules';
import { ReviewScreen } from './ReviewScreen';

/** The route `/app/review` (design review-form a1-a10): the review form of the signed-in user. */
const ReviewViewComponent: React.FC = () => {
  const intl = useIntl();
  const title = intl.formatMessage(reviewMessages.title);
  const breadcrumbs = useMemo(() => [{ name: title }], [title]);
  const [params] = useSearchParams();
  const from = reviewFromOf(params.get('from'));
  useEffect(() => {
    trackEvent('review_form_opened', { from });
  }, [from]);

  return (
    <SMLContainer
      hidePricingModal
      header={
        <SMLPageHead breadcrumbs={breadcrumbs} title={title} subtitle={intl.formatMessage(reviewMessages.subtitle)} />
      }
    >
      <ReviewScreen />
    </SMLContainer>
  );
};

export const ReviewView = TypedMemo(ReviewViewComponent);
